import { render, staticRenderFns } from "./TodoRoadmap.vue?vue&type=template&id=52d72314"
import script from "./TodoRoadmap.vue?vue&type=script&lang=js"
export * from "./TodoRoadmap.vue?vue&type=script&lang=js"
import style0 from "./TodoRoadmap.vue?vue&type=style&index=0&id=52d72314&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports